// Capstone Project
// John, Isabel, Nick, Bobur

import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import SpaceCreate from "./SpaceCreate";
import SpaceTable from "./SpaceTable";
import { useParams } from "react-router-dom";
import Sidebar from "../../Sidebar";
import Filter from "../../Calendar/Filter";
import { Grid } from "@mui/material";
import APIURL from "../../../helper/environment";

const ParkingSpaceIndex = (props) => {
  const [parkingSpaces, setParkingSpaces] = useState([]);
  const { parkingLot_id } = useParams(); //Assocaites a Space with a given Lot
  const token = props.token;
  let parkingLotID = props.parkingLots._id; //Assocaites a Space with a given Lot
  console.log("Parking Space Index", props);

  async function showAllSpaces() {
    let url = `${APIURL}/parking-space/display-all`;

    let myHeaders = new Headers();
    myHeaders.append("Authorization", token); // token in header is for authorization

    const requestOptions = {
      headers: myHeaders,
      method: "GET",
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      setParkingSpaces(data.parkingSpaces);
    } catch (error) {
      console.error(error.message);
    }
  }
  async function showAllLotsSpaces() {
    //TODO added this function
    let url = `${APIURL}/parking-space/display-by-lot/` + parkingLot_id;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", token); // token in header is for authorization

    const requestOptions = {
      headers: myHeaders,
      method: "GET",
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      setParkingSpaces(data.parkingSpaces);
    } catch (error) {
      console.error(error.message);
    }
  }
  useEffect(() => {
    if (token) {
      //showAllSpaces(); //! TEST
      console.log("ParkingLots 1", props);
      showAllLotsSpaces();
      console.log("ParkingLots 2", props.parkingLots);
    }
  }, [token]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">{/* <Sidebar /> */}</div>
        </div>
      </div>

      <Container>
        <Row>
          <Col md="4">
            <SpaceCreate
              token={props.token}
              showAllSpaces={showAllSpaces}
              showAllLotsSpaces={showAllLotsSpaces}
              parkingLot_id={parkingLot_id}
            />
          </Col>
          <Col md="8">
            <SpaceTable
              parkingSpaces={parkingSpaces}
              token={token}
              showAllSpaces={showAllSpaces}
              showAllLotsSpaces={showAllLotsSpaces}
              parkingLotID={parkingLotID}
            />
          </Col>
          <Col xs="12" md="12" mt="12"></Col>
        </Row>

        <Row className="RowCalendar"></Row>
        <Filter />
      </Container>
    </>
  );
};

export default ParkingSpaceIndex;
